import React, { useContext, useEffect } from 'react';
import { convertPropsToObject } from '../ContentRender';
import { RowHeader } from './RowHeader';
import MaxWidth from '../../Layout/MaxWidth';
import { ProductRowComponentWrapper } from './ProductRowComponent';
import AddwishRow from '../../ui/AddwishRow/AddwishRow';
import ChannelContext from '@jetshop/core/components/ChannelContext';
import { useAddwish } from '@jetshop/flight-addwish';
import Spinner from '../../ui/Spinner';



const AddwishContainer = ({ data }) => {
  const [hrReady, setHrReady] = React.useState(false);

  useEffect(() => {
    let hrInitCounter = 0;
    let hrInterval = null;

    if (!hrReady) {
      if (!window?.HELLO_RETAIL?.initialized && hrInitCounter < 20) {
        hrInterval = setInterval(() => {
          hrInitCounter++;
          if (window?.HELLO_RETAIL?.initialized) {
            clearInterval(hrInterval);
            setHrReady(true);
          }
          if (hrInitCounter >= 20) {
            console.log(
              'Tried too init HR/Addwish boxes too many times, stop trying -> init render anyway'
            );
            clearInterval(hrInterval);
            setHrReady(true);
          }
        }, 500);
      } else {
        setHrReady(true);
      }
    }
    return () => {
      if (hrInterval) clearInterval(hrInterval);
    };
  }, [hrReady]);

  return hrReady ? (
    <AddwishComponent data={data}  />
  ) : (
    <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
      <Spinner />
    </div>
  );
};


const AddwishComponent = ({ data }) => {
  const props = convertPropsToObject(data);
  const id = props.id.value;
  const slider = props.slider.value === 'yes' ? true : false;

  //ADDWISH
  const { selectedChannel } = useContext(ChannelContext);
  const { addWishResponseBoxItems } = useAddwish({
    boxes: {
      [id]: {
        url: selectedChannel.url
      }
    },
    pageLoaded: true
  });

  return (
    <MaxWidth>
      <ProductRowComponentWrapper>
        <RowHeader props={props} />
        <AddwishRow
          data={addWishResponseBoxItems[id]}
          id={id}
          slider={slider}
        />
      </ProductRowComponentWrapper>
    </MaxWidth>
  );
};

export default AddwishContainer;
